import React, { Fragment } from "react";
import ComponentImage from "./ComponentImage/ComponentImage";
import ComponentVideo from "./ComponentVideo/ComponentVideo";

const ContainerComponents = ({ options }) => {
  //Des
  const { objinfo = {} } = options;
  const { content = {} } = objinfo || {};

  const components = {
    image: <ComponentImage options={options} />,
    video: <ComponentVideo options={options} />,
  };

  const actual_component = components[content?.type] || false;

  return <Fragment>{actual_component}</Fragment>;
};

export default ContainerComponents;
